/** @jsxImportSource theme-ui @jsxRuntime classic */
import React from 'react';
import { Select, useScrollTo } from '@tishman/components';

export function CategoryChooser({
  categories,
}: {
  categories: Queries.BuyTicketsQuery['allSanityTicketCategory']['nodes'];
}): React.JSX.Element {
  const scrollTo = useScrollTo();
  return (
    <Select
      name="ticket"
      onChange={(e) => {
        scrollTo(`${e.target.value}`);
      }}
      sx={{
        fontWeight: 300,
      }}
    >
      <option disabled hidden>
        Explore Tickets
      </option>
      ;
      {categories.map((category) => (
        <option key={category.id} value={category.slug?.current ?? ''}>
          {category.title}
        </option>
      ))}
    </Select>
  );
}
